import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { WithApp } from "contexts/appContext";
import { wsGetAll } from "services/WService";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { wsUpdate } from "services/WService";
import { wsGet } from "services/WService";
import useItemChanges from "hooks/useItemChanges";

const useStyles = makeStyles(() => ({
  closeButton: {
    float: "right"
  }
}));

export default WithApp(function BureauModal(props) {
  const classes = useStyles();

  const { open, setOpen, bureauId } = props;

  const handleClose = () => {
    setOpen(false);
  };

  const [bureau, setBureau] = useState({});
  const [bureauLoaded, setBureauLoaded] = useState({});
  const itemChanges = useItemChanges(bureauLoaded, bureau);

  async function getBureau() {
    setBureauLoaded({});
    let response = await wsGet("base/customer-bureau", bureauId);
    if (response.success) {
      setBureau(response.data);
      setBureauLoaded(response.data);
    }
  }

  const [canals, setCanals] = useState([]);

  async function listCanals() {
    let response = await wsGetAll("base/canal");
    if (response.success) setCanals(response.data);
  }

  const handleSave = () => {
    if (itemChanges) {
      updateBureau(itemChanges);
    }
  };

  const handleChange = (e) => {
    setBureau({
      ...bureau,
      [e.target.name]: e.target.value
    });
  };

  async function updateBureau(data) {
    /* console.log("base/customer-bureau", bureau.id, data); */
    let response = await wsUpdate("base/customer-bureau", bureau.id, data);
    if (response.success) {
      props.reload();
      props.showNotify(response.message);
      handleClose();
    }
  }

  useEffect(() => {
    if (open) {
      getBureau();
      listCanals();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {bureau.base_bureau_description || ""}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Canal</InputLabel>
          <Select
            value={bureau.base_canal_id || ""}
            inputProps={{
              name: "base_canal_id",
              onChange: handleChange
            }}
          >
            {canals.map((canal, i) => {
              return (
                <MenuItem value={canal.id} key={i}>
                  {canal.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Frecuencia</InputLabel>
          <Select
            value={bureau.frecuency || ""}
            inputProps={{
              name: "frecuency",
              onChange: handleChange
            }}
          >
            <MenuItem value="D">Diario</MenuItem>
            <MenuItem value="M">Mensual</MenuItem>
            <MenuItem value="Q">Quincenal</MenuItem>
            <MenuItem value="S">Semanal</MenuItem>
            <MenuItem value="F">Sin frecuencia</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Estado</InputLabel>
          <Select
            value={bureau.state || ""}
            inputProps={{
              name: "state",
              onChange: handleChange
            }}
          >
            <MenuItem value="A">Activo</MenuItem>
            <MenuItem value="I">Inactivo</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSave}
          color={props.themeContext.buttonColorSuccess}
        >
          Guardar
        </Button>
        <Button
          onClick={handleClose}
          color={props.themeContext.buttonColorDanger}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
});
